import React = require('react');

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { SiteUserAuthenticationProviderContext } from '~src/userManagement/users/components/siteUsersSpace/UserAuthenticationProviderContext';
import { ISiteUserInfo } from '~src/userManagement/users/models/ISiteUserInfo';

import { ISiteAuthenticationSettings, SiteAuthenticationSettingsService } from '../../../../../src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { Messages } from '../../../../codegen/Localize';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { GrantLicenseModes } from '../../../../ts/ServerApi/requests/SyncActiveDirectoryGroupRequest';
import _ = require('underscore');

export type GroupUsersSubspaceProps = GroupUsersSubspaceOwnProps;

export interface GroupUsersSubspaceOwnProps {
    readonly group: IGroupInfo;
    readonly canSessionUserManageUsers: boolean;
    readonly addSiteUsersToGroup: (group: IGroupInfo) => void;
}

interface GroupUsersSubspaceState {
    readonly renderChildren: boolean;
    readonly siteAuthenticationSettings: ISiteAuthenticationSettings;
}

export interface IGroupDetailsModel {
  domainName: string;
  createdAt: string;
  updatedAt: string;
  isAllUsersGroup: boolean;
  minimumSiteRole?: string;
  grantLicenseMode?: GrantLicenseModes;
}

export class GroupUsersSubspace extends React.Component<GroupUsersSubspaceProps, GroupUsersSubspaceState> {

  public constructor(props: GroupUsersSubspaceProps) {
    super(props);
    this.state = {
        renderChildren: false, siteAuthenticationSettings: undefined
    };
  }

  public componentDidMount() {
    this.getSiteAuthenticationSettings();
  }

  public componentDidUpdate(prevProps: GroupUsersSubspaceProps) {
    if (!this.state.renderChildren && !_.isUndefined(this.state.siteAuthenticationSettings)) {
      this.setState({renderChildren: true});
    }
  }

  public render() {
    if (this.state.renderChildren) {
      return (<SiteUserAuthenticationProviderContext.Provider value={this.authenticationProvider}>
                    <ConnectedExplorer
                      supportedDisplayModes={['list']}
                      toolbarProps={{
                        supportFilterPanel: true,
                        toolbarVisibility: 'enabled',
                        toolbarContentSpecificControls: { beginning: this.addUsersButton(this.props.group, this.props.canSessionUserManageUsers, this.props.addSiteUsersToGroup)}
                      }}
                    />
                  </SiteUserAuthenticationProviderContext.Provider>
              );
    } else {
      return (<div></div>);
    }
  }

  private authenticationProvider = (user: ISiteUserInfo) => {
    const provider = SiteAuthenticationSettingsService.findProvider(this.state.siteAuthenticationSettings, user.authenticationProviderId);
    if (provider) {
      return {
        name: SiteAuthenticationSettingsService.getProviderDisplayName(provider),
        isEnabled: provider.isEnabled
      };
    } else {
      return {
        name: Messages.unspecified(),
        isEnabled: false
      };
    }
  }

  private getSiteAuthenticationSettings = async () => {
    const siteAuthenticationSettings = await SiteAuthenticationSettingsService.getSiteAuthenticationSettings();
    this.setState({siteAuthenticationSettings});
  }

  private addUsersButton(group: IGroupInfo,
    canSessionUserManageUsers: boolean,
    addSiteUsersToGroup: (group: IGroupInfo) => void): JSX.Element {
    if (canSessionUserManageUsers || this.isGroupWithoutLicenseUponLogin(group)) {
      const handleClick = () => addSiteUsersToGroup(group);
      return (
        <ButtonWidget
          children={Messages.addUsers()}
          buttonType={ButtonType.Outline}
          handleClick={handleClick}
          tb-test-id={'action-add-users'}
          testId={'action-add-users'}/>
      );
    }
    return null;
  }

  private isGroupWithoutLicenseUponLogin(group: IGroupInfo) {
    return group.grantLicenseMode !== GrantLicenseModes.ON_LOGIN;
  }
}
